// The unlock card's fireworks (spec web/achievements, 4) as timed beats on the case's particle
// engine (`platform/case/effects.ts`): a burst a beat around the card, rarer tiers more of them,
// one for an Extra up to six holographic ones for a Cult Classic. Pure, so each tier's plan is
// tested; the card draws it, and reduced motion draws none.
import type { Tier } from "../../api/generated/model";
import palette from "../case/effects.json";
import { burst, ring, type Beat } from "../case/effects";

const BURSTS: Record<Tier, number> = {
  extra: 1,
  "supporting-role": 2,
  "leading-role": 3,
  "directors-cut": 4,
  "cult-classic": 6,
};

/** Where the card sits, in the viewport's CSS pixels. */
export interface Box {
  left: number;
  top: number;
  width: number;
}

/** Each burst above and around the card, 220 ms apart, in the tier's colour and white, or every
 *  firework colour for a Cult Classic. */
export function fireworks(tier: Tier, color: string, box: Box, random: () => number): Beat[] {
  const colors = tier === "cult-classic" ? palette.fireworks : [color, palette.white];
  return Array.from({ length: BURSTS[tier] }, (_, at) => ({
    at: at * 220,
    run: (scene) => {
      const x = box.left - 60 + random() * (box.width + 60);
      const y = box.top - 40 - random() * 140;
      const hue = colors[at % colors.length] ?? palette.white;
      ring(scene, x, y, hue, 90, 36, 3);
      burst(scene, x, y, [hue, palette.white], 70, 7, { life: 60, gravity: 0.08 }, random);
    },
  }));
}
